import iconNotes from "../../../../design/assests/images/icons/Notes.png"

export const buildNotesSection = async (doc, y, notes) => {
  if (!notes?.trim()) return y

  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()

  const sideMargin = 10
  const bottomMargin = 25

  const titleColor = "#24292F"
  const textColor = "#24292F"

  const iconSize = 6.5
  const spacing = 3
  const iconOffsetY = 4.5

  const bulletIndent = 2
  const bulletGap = 2

  if (y > pageHeight - 60) {
    doc.addPage()
    y = 20
  }

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(11)
  doc.setTextColor(titleColor)

  doc.addImage(
    iconNotes,
    "PNG",
    sideMargin,
    y - iconOffsetY,
    iconSize,
    iconSize
  )

  doc.text("Notas del reporte", sideMargin + iconSize + spacing, y)

  y += 10

  const lines = notes.split("\n")
  const bulletRegex = /^-\s*(.+)$/

  doc.setFont("Mulish-Regular", "normal")
  doc.setFontSize(9)
  doc.setTextColor(textColor)

  for (const line of lines) {
    const trimmed = line.trim()

    if (!trimmed) {
      y += 2
      continue
    }

    const bulletMatch = trimmed.match(bulletRegex)
    const isBullet = !!bulletMatch

    const text = isBullet ? bulletMatch[1] : trimmed

    const textX =
      isBullet ? sideMargin + bulletIndent + bulletGap + 2 : sideMargin

    const maxWidth =
      isBullet ? pageWidth - textX - sideMargin : pageWidth - sideMargin * 2

    const wrapped = doc.splitTextToSize(text, maxWidth)

    if (y + wrapped.length * 5 > pageHeight - bottomMargin) {
      doc.addPage()
      y = 20
    }

    // dibujar bullet separado
    if (isBullet) {
      doc.text("•", sideMargin + bulletIndent, y)
    }

    // dibujar texto alineado
    doc.text(wrapped, textX, y)

    y += wrapped.length * 4.2 + 0.8
  }

  return y + 6
}
